import BaseModelFactory from './base.factory'
import UserAccomplishmentService from './../services/UserAccomplishment.service'
import UserAccomplishment from './../models/user-accomplishment.model'

class UserAccomplishmentFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: UserAccomplishmentService, Model: UserAccomplishment }
    )
  static findById = async id =>
    await this._findBy({ id: id }, { Service: UserAccomplishmentService, Model: UserAccomplishment })
  static findAllByUserId = async id =>
    await this._findAllBy({ user_id: id }, { Service: UserAccomplishmentService, Model: UserAccomplishment })
  static findAll = async () =>
    await this._findAllBy({}, { Service: UserAccomplishmentService, Model: UserAccomplishment })
  static create = payload =>
    this._create(payload, {
      Service: UserAccomplishmentService,
      Model: UserAccomplishment,
    })
}

export default UserAccomplishmentFactory
